import React, { useEffect, useState } from "react";
import PlanCard from "./PlanCard";
import apiRequest from "utils/ApiRequest/apiRequest";

interface ApiResponseI {
  status: string;
  data?: CardI[];
}

export interface CardI {
  Subscription_Id: string;
  Subscription_SystemName: string;
  SaleCoupon: {
    [key: string]: string | number;
  };
  Prices: {
    Price_Yearly: {
      [key: string]: number;
    };
    Price_Monthly: {
      [key: string]: number;
    };
  };
}

interface CardsContainerI {
  isYearly: boolean;
  setClickedCard: React.Dispatch<React.SetStateAction<string>>;
  setPrices?: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  setCoupons?: React.Dispatch<React.SetStateAction<Record<string, any>>>;
}

const CardsContainer = ({
  isYearly,
  setClickedCard,
  setPrices,
  setCoupons,
}: CardsContainerI) => {
  const [cards, setCards] = useState<CardI[]>([]);

  const getPlansCards = async (): Promise<void> => {
    const res: ApiResponseI = await apiRequest(
      "Packages",
      "GetAllActiveJMPlansReact"
    );
    if (res.status === "success" && res.data !== undefined) {
      // sorting by price from low to high
      setCards(
        res.data.sort((a, b) => {
          // except enterprise solution wich is dont have price but should be last in order
          if (a.Subscription_SystemName === "enterprise") {
            return 1;
          }
          return a.Prices.Price_Monthly.USD > b.Prices.Price_Monthly.USD
            ? 1
            : -1;
        })
      );
      // setting prices to state to provide to fetures table
      res.data.map((card) => {
        if (setPrices) {
          setPrices((prev) => ({
            ...prev,
            [card.Subscription_SystemName]: {
              Price_Yearly: card.Prices.Price_Yearly,
              Price_Monthly: card.Prices.Price_Monthly,
            },
          }));
        }
        if (setCoupons) {
          setCoupons((prev) => ({
            ...prev,
            [card.Subscription_SystemName]: card.SaleCoupon,
          }));
        }
      });
    }
  };

  useEffect(() => {
    getPlansCards();
  }, []);

  return (
    <div className="plans-cards-container">
      {cards
        .slice(0, window.location.pathname.includes("purchase") ? 2 : 4)
        .map((card: CardI) => (
          <PlanCard
            key={card.Subscription_Id}
            {...{
              card,
              isYearly,
              setClickedCard,
            }}
          />
        ))}
    </div>
  );
};

export default CardsContainer;
